/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { CellType } from "@nf/common";
import { useBreakpoints } from "../../../../../index";

export const getGridItemCount = (
  breakpoint?: string,
  columns?: number,
  cellType?: string
) => {
  if (cellType === CellType.Frame || cellType === CellType.FrameLarge) {
    switch (breakpoint) {
      case "XS":
        return 2;
      case "SM":
        return 3;
      default:
        return columns || 3;
    }
  }
  switch (breakpoint) {
    case "XS":
      return 3;
    case "SM":
      return 6;
    case "MD":
      return columns;
    case "LG":
      return columns;
    case "XL":
      return columns;
    default:
      return columns || 3;
  }
};

export const useGridtemCount = (columns?: number, cellType?: string) => {
  const { breakpoint } = useBreakpoints();

  return getGridItemCount(breakpoint, columns, cellType);
};
